<template>
  <div class="header" id="top">
      <div class="logo"><img src="../../assets/images/logoPc.png" style="width: 253px;height: 65px;"/></div>
      <div class="boxHeadCenter">
        <ul class="headNav">
          <li class="index"><router-link to="/index">&nbsp;&nbsp;首 页&nbsp;&nbsp;&nbsp;&nbsp;</router-link></li>
          <li><router-link to="/products" :class="{'routerActive':curNav=='product'}">装备商城</router-link></li>
          <li><router-link to="/activetys" :class="{'routerActive':curNav=='activety'}">运动旅行</router-link></li>
          <li><router-link to="/news" :class="{'routerActive':curNav=='news'}">线路攻略</router-link></li>
          <li class="feedback"><router-link to="/feedback">&nbsp;留言板&nbsp;&nbsp;</router-link></li>
          <li><router-link to="/album" >相册留影</router-link></li>
          <li><router-link to="/aboutUs">会员咨询</router-link></li>
        </ul>
        <div class="headSearch">
            <input type="text"/>
            <div class="btn"></div>
          </div>
          <div class="userInfo">
          <router-link to="/car"><p class="carEntry" v-if="userData">购物车</p></router-link>
          <p class="userNickname" v-if="userData">{{userData.nickname}}</p>
          <div class="userLogin" v-if="!userData" @click="wxLogin">
            <span class="span1">登录</span> 
            <span class="span2">请登录</span>
          </div>
          <div class="imgBox" @mouseenter="userFastOp" @mouseleave="userFastOpOff">
            <img v-if="userData" :src="userData.headPic"/> 
            <img v-if="!userData" src="../../assets/images/userHeadDefalse.png"/>
          </div>
        </div>
        <div class="quickOp" v-if="userData" v-show="quickOpFlag" @mouseenter="userFastOp" @mouseleave="quickOpFlag = false">
          <ul>
            <router-link to="/user"><li class="usreCenter">个人中心</li></router-link>
            <li class="loginOut" @click="loginOut">退出登录</li>
          </ul>
          <div class="triangle-up"></div>
        </div>
      </div>
      <!-- <div class="userInfo">
        <router-link to="/car"><p class="carEntry">购物车</p></router-link>
        <p class="userNickname">风继续吹</p>
        <div class="imgBox" @mouseenter="userFastOp" @mouseleave="userFastOpOff">
          <img  src="../../assets/images/userHeadDefalse.png"/>
        </div>
      </div>
      <div class="quickOp" v-show="quickOpFlag" @mouseenter="userFastOp" @mouseleave="quickOpFlag = false">
        <ul>
          <router-link to="/user"><li class="usreCenter">个人中心</li></router-link>
          <li class="loginOut">退出登录</li>
        </ul>
      </div> -->

      <div class="rightSide">
        <div class="qqwx">
            <div class="item item1">
              <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=707390353&site=qq&menu=yes"><div class="qqchatBox">在线联系</div></a>
            </div>
            <div class="item item2">
              <div class="wxchatBox">
                <img src="../../assets/images/wx_new.jpg"/>
                <p>微信扫码联系</p>
              </div>
            </div>
        </div>
        <div class="toTop" @click="toTop" v-show="isActive">回顶部</div>
      </div>
      <el-dialog :visible.sync="detailVisiable" append-to-body width="338px">
        <wxlogin class="wxloginClass" href="data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwNXB4O30NCi5pbXBvd2VyQm94IC50aXRsZSB7Zm9udC1zaXplOiAyMHB4O2NvbG9yOiAjMzMzMzMzO21hcmdpbi10b3A6MjBweDt9DQouaW1wb3dlckJveCAgLnN0YXR1c19icm93c2VyIHArcHtkaXNwbGF5OiBub25lO2ZvbnQtc2l6ZTogMjBweDt9DQouaW1wb3dlckJveCAgLmluZm97bWFyZ2luLXRvcDoxMHB4O2NvbG9yOiAjMzMzMzMzO30=" :appid="'wx54ec39f0389c805f'" :self_redirect="false" :scope="scope" :redirect_uri="redirect_uri"></wxlogin>
      </el-dialog>
  </div>
</template>

<script>
import eventVue from '../../bus.js'
import store from '@/store/index.js'
import wxlogin from 'vue-wxlogin';
export default {
  components: {
      wxlogin
  },
  data(){
    return{
      curNav:'',
      timer:null, //滚动
      timmer:false, //右上角快速操作
      isActive:false,
      quickOpFlag:false,
      //userData:null,
      scope:'snsapi_login',
      redirect_uri:encodeURI('http://www.tindoe.com'),
      detailVisiable:false
    }
  },
  computed: {
    userData() {
      return this.$store.state.userData
    },
    userId() {
      return this.$store.state.userId
    }
  },
  watch: {
    userId: {
      handler(newName, oldName){
        if (newName) {
          this.getUserDataById()
        }
      },
      immediate: true
    }
  },
  created(){
    window.onscroll = ()=>{
      if (document.documentElement.scrollTop>200) {
        this.isActive=true;
      }else {
        this.isActive=false;
      }
    }
  },
  mounted(){
    eventVue.$on("navSwitch",(message)=>{
      this.curNav = message
    })
    eventVue.$on("callLogin",(message)=>{
      this.wxLogin()
    })
    eventVue.$on("getUserInfo",(message)=>{
      this.getUserDataById()
    })
    //this.getUserDataById()
  },
  methods:{
    toTop(){ // 动画
       this.timer = setInterval(()=>{
        let osTop = document.documentElement.scrollTop || document.body.scrollTop
        let ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
        console.log(osTop)
        if (osTop <= 0) {
          clearInterval(this.timer)
        }
      },30)
    },
    //根据微信用户ID 获取用户信息
    getUserDataById(){
      // if(this.userData){
      //   return
      // }
      if(sessionStorage.getItem("userId")){
        this.$https.get('/api/member/memberId/'+sessionStorage.getItem("userId")).then((response)=>{
          console.log(response ,111111111111111111)
          this.$store.state.userData = response.data
          //this.userData = response.data
        });
      }else{
        store.state.userData = null
      }
    },
    userFastOp:function(){
        clearTimeout(this.timmer)
        this.quickOpFlag = true
    },
    userFastOpOff:function(){
        this.timmer = setTimeout(()=>{
            this.quickOpFlag = false
        },200)
    },

    //微信login
    wxLogin(){
      this.detailVisiable = true
      // window.open('https://open.weixin.qq.com/connect/qrconnect?appid=wx54ec39f0389c805f&redirect_uri=http%3A%2F%2Fwww.tindoe.com/&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect',"_self")
    },
    loginOut(){
      this.$https.get('/api/logout').then((res)=>{
          if(res.code == 0){
            store.state.userData = null
            sessionStorage.removeItem("userId")
            this.$router.replace('/')
          }
        }).catch((error) => {

        });
    },
  }
}
</script>

<style scoped>
  .impowerBox .qrcode{
    width: 205px;
  }
  .rightSide{
    position: fixed;
    top: 300px;
    right: 20px;
    color: red;
    z-index: 999;
  }
  .toTop{
    margin-top: 12px;
    width: 54px;
    height: 49px;
    border: 1px solid #F6F6F6;
    cursor: pointer;
    border-radius: 4px;
    background-color: #C1CACF;
    background-image: url("../../assets/images/up2.png");
    background-repeat: no-repeat;
    background-size: 22px 12px;
    background-position: 17px 9px;
    text-align: center;
    overflow: hidden;
    font-size: 14px;
    line-height: 68px;
    color: #ffffff;
  }
  .toTop:hover{
    background-color: #5680F9;
    /*background-image: url("../../assets/images/up2.png");
    background-repeat: no-repeat;
    background-size: 22px 12px;
    background-position: 17px 9px;*/
    color: #ffffff;
  }
  .rightSide .qqwx{
    width: 54px;
    border: 1px solid #ECECEC;
    border-radius: 4px;
  }
  .rightSide .qqwx .item{
    width: 54px;
    height: 49px;
    background-color: #F6F6F6;
    cursor: pointer;
    position: relative;
  }
  .qqchatBox{
    display: none;
    position: absolute;
    top: 0px;
    left: -125px;
    width: 78px;
    height: 47px;
    padding-left: 45px;
    line-height: 47px;
    color: #747474;
    font-size: 14px;
    background-color: #FFFFFF;
    border: 1px solid #ECECEC;
    box-shadow: 0px 0px 5px 0px rgba(234, 234, 234, 0.35);
    background-image: url("../../assets/images/qq3.png");
    background-repeat: no-repeat;
    background-size: 22px 23px;
    background-position: 14px 13px;
  }
  .rightSide .qqwx .item:hover .qqchatBox{
    display: block;
  }
  .wxchatBox{
    display: none;
    position: absolute;
    top: 0px;
    left: -125px;
    width: 123px;
    height: 138px;
    font-size: 14px;
    border: 1px solid #ECECEC;
    background-color: #ffffff;
    box-shadow: 0px 0px 5px 0px rgba(234, 234, 234, 0.35);
  }
  .rightSide .qqwx .item:hover .wxchatBox{
    display: block;
  }
  .wxchatBox img{
    display: block;
    width: 100px;
    height: 100px;
    margin: 10px auto 0;
  }
  .wxchatBox p{
    font-size: 14px;
    color: #747474;
    text-align: center;
    margin-top: 5px;
  }
  .rightSide .qqwx .item1{
    background-color: #C1CACF;
    border-radius: 4px 4px 0px 0px;
    background-image: url("../../assets/images/qq2.png");
    background-repeat: no-repeat;
    background-size: 22px 23px;
    background-position: 16px 13px;
  }
  .rightSide .qqwx .item1:hover{
    background-color: #5680F9;
    /*background-image: url("../../assets/images/qq2.png");
    background-repeat: no-repeat;
    background-size: 22px 23px;
    background-position: 16px 13px;*/
  }
  .rightSide .qqwx .item2{
    background-color: #C1CACF;
    border-radius: 0px 0px 4px 4px;
    background-image: url("../../assets/images/wx2.png");
    background-repeat: no-repeat;
    background-size: 29px 24px;
    background-position: 13px 14px;
  }
  .rightSide .qqwx .item2:hover{
    background-color: #5680F9;
    /*background-image: url("../../assets/images/wx2.png");
    background-repeat: no-repeat;
    background-size: 29px 24px;
    background-position: 13px 14px;*/
  }
  .logo{
    position: absolute;
    top: 5px;
    left: 54px;
    font-size: 30px;
    color: #5680f9;
  }
  .routerActive{
    background: #5680f9;
    color: #FFFFFF !important;
  }
  .header{
    height: 90px;
    width: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background: #5680F9;
    z-index: 999;
  }
  .boxHeadCenter{
    width: calc(100% - 330px - 240px);
    padding: 0 240px 0 330px;
    min-width: 1000px;
    position: relative;
  }
  .headNav{
    width: 100%;
    text-align: center;
  }
  .headNav li{
    display: inline-block;
    padding-top: 30px;
  }
  .headNav li a{
    display: inline-block;
    height: 36px;
    line-height: 36px;
    padding: 0 42px 0 15px;
    color: #ffffff;
    font-size: 20px;
    cursor: pointer;
    text-decoration: none;
  }
  .headNav li a.router-link-active{
    background-image: url("../../assets/images/navCurBg3.png");
    background-repeat: no-repeat;
    background-size: 136px 36px;
    color: #FFFFFF;
  }
  .headNav li.index .router-link-active{
    background-image: url("../../assets/images/navCurBg1.png");
  }
  .headNav li.feedback .router-link-active{
    background-image: url("../../assets/images/navCurBg2.png");
  }
  .headSearch{
    display: none;
    width: 198px;
    border: 1px solid #5680f9;
    border-radius: 50px;
    position: absolute;
    top: 41px;
    right: -105px;
    height: 50px;
    overflow: hidden;
  }
  .headSearch input{
    border: 0px;
    height: 50px;
    line-height: 50px;
    width: 100%;
    padding: 0 15px;
    outline:none;
  }
  .headSearch .btn{
    position: absolute;
    width: 31px;
    height: 31px;
    right: 15px;
    top: 9px;
    background: url("../../assets/images/search-icon.png") no-repeat;
  }
  .userInfo{
    position: absolute;
    top: 14px;
    right: 30px;
    color: #ffffff;
  }
  .userInfo .userNickname{float: left; height:66px; line-height: 66px; max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #ffffff;font-size: 18px;margin-right: 15px;}
  .userInfo .carEntry{
    float: left;line-height: 66px;color: #ffffff;font-size: 18px;
    background-image: url("../../assets/images/car.png");
    background-repeat: no-repeat;
    background-position: right 10px center;
    padding-right: 35px;
    background-size: 23px 21px;
    cursor: pointer;
    margin-right:20px;
  }
  .userInfo .userLogin{
    width: 105px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #5680F9;
    border-radius: 10px;
    float: left;
    font-size: 18px;
    color: #ffffff;
    margin: 12px 15px 0 0;
    text-align: center;
    cursor: pointer;
    position: relative;
  }
  .userInfo .userLogin:hover{
    color: #ffffff;
    background: #5680F9;
  }
  .userInfo .userLogin .span2{
    display: none;
  }
  .userInfo .userLogin:hover .span1{
    display: none;
  }
  .userInfo .userLogin:hover .span2{
    display: block;
  }
  .userInfo .imgBox{
    float: left;
    width:64px;
    height:64px;
    background:rgba(197,212,255,1);
    border-radius:50%;
    overflow: hidden;
  }
  .userInfo .imgBox img{
    width: 100%;
    height: 100%;
  }
  .quickOp{
    position: absolute;
    right: 0px;
    top: 85px;
    z-index: 999;
    padding: 2px;
    background: #ffffff;
    border-radius: 4px;
  }
  .quickOp .triangle-up {
    position: absolute;
    top: -16px;
    right: 50px;
      width: 0px;
      height: 8px;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid #ffffff;
  }
  .usreCenter{
    background-image: url("../../assets/images/userCenter.png");
    background-repeat: no-repeat;
    background-position: 20px 10px;
    background-color: #ffffff;
    width:106px;
    height:40px;
    line-height: 40px;
    padding-left: 50px;
    border-radius:4px 4px 0px 0px;
    font-size: 16px;
    color: #666666;
    cursor: pointer;
  }
  .usreCenter:hover{
    background-image: url("../../assets/images/userCenterh.png");
    background-repeat: no-repeat;
    background-position: 20px 10px;
    background-color: #5680F9;
    color: #fff;
  }
  .loginOut{
    background-image: url("../../assets/images/loginout.png");
    background-repeat: no-repeat;
    background-position: 20px 10px;
    background-color: #ffffff;
    width:106px;
    height:40px;
    line-height: 40px;
    padding-left: 50px;
    border-radius:0px 0px 4px 4px;
    font-size: 16px;
    color: #666666;
    cursor: pointer;
  }
  .loginOut:hover{
    background-image: url("../../assets/images/loginouth.png");
    background-repeat: no-repeat;
    background-position: 20px 10px;
    background-color: #5680F9;
    color: #fff;
  }

  .wxloginClass{
    /*position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    background: #ffffff;
    padding: 20px;
    box-shadow: 1px 2px 30px 2px rgba(0,0,0,0.5);*/
  }
  

  /deep/ .el-dialog__body{
    padding: 0px;
  }
  /deep/ .el-dialog__header{
    padding-top: 0px;
  }
</style>
<style type="text/css">
  .wxloginClass iframe{
    width: 338px !important;
    height: 352px !important;
  }
</style>





// WEBPACK FOOTER //
// src/components/common/header.vue